import {Component, Input, OnInit} from '@angular/core';
import {durationToStr} from 'shared';

export interface TimePieChartEntry {
  name: string;
  duration: number;
}

@Component({
  selector: 'app-time-pie-chart',
  templateUrl: './time-pie-chart.component.html',
  styleUrls: ['./time-pie-chart.component.scss']
})
export class TimePieChartComponent implements OnInit {

  @Input()
  title: string;

  @Input()
  width: number;

  @Input()
  height: number;

  @Input()
  data: TimePieChartEntry[];

  constructor() {
  }

  ngOnInit(): void {
  }

  customizeLabel(arg) {
    return durationToStr(arg.value) + ' (' + arg.percentText + ')';
  }

}
